import moment from 'moment';

const _m = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

export const toPricingWeekday = (date: Date): string => {
  const weekDayMom = moment(date).isoWeekday() - 1;
  return _m[weekDayMom];
};
